import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as API from './sagas.helper';
import * as Constants from './Constants';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { safetechInit } from '../../components/common/Helpers/safetech';
import { isExpressCheckout, reflect } from '../../components/common/Helpers/index';

function* callGetCheckoutDetails({ data }) {
  let errorDetails = false;
  // debugger;
  try {
    showLoader();
    yield put({ type: Constants.GET_CHECKOUT_DETAILS_SUCCESS, response: false });
    yield put({ type: Constants.CEF_CHECKOUT_DETAILS_ERROR, response: false, errorMessage: null });
    yield put({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
    let apiResponse;
    let restResponse;
    const { isCassNeeded = false } = data || {};
    if (isExpressCheckout() && isCassNeeded) {
      const apiActions = [{ url: API.getCheckoutDetailsCall, data }];
      apiActions.push({ url: API.getCheckoutCQ });
      [apiResponse, ...restResponse] = yield all(apiActions.map(reflect));
    } else {
      apiResponse = yield call(API.getCheckoutDetailsCall, data);
    }

    // const apiResponse = yield call(API.getCheckoutDetailsCall, data);
    if (apiResponse && apiResponse.data && apiResponse.status === 200 && !apiResponse.data.errors) {
      yield put({ type: 'INVOKE_TAGGING' });
      yield put({ type: Constants.GET_CHECKOUT_DETAILS_RESPONSE, response: apiResponse.data });
      yield put({ type: Constants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
      yield put({ type: 'UPDATE_API_STATUS', response: 'COMPLETED' });
      yield put({ type: 'API_LOADED', response: true });

      if (apiResponse && apiResponse.data?.data && apiResponse?.data?.data?.cart?.safeTechSessionId && window.location.href.includes('orderreview')) {
        console.log(apiResponse?.data?.data?.cart?.safeTechSessionId);
        safetechInit(apiResponse?.data?.data?.cart?.safeTechSessionId);
      }
    } else {
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorDetails = true;
        if (apiResponse?.data?.errors) {
          if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCheckOutDetails ${apiResponse?.data?.loggerData.note}`;
          logger(apiResponse?.data?.loggerData);
        }
        yield put({ type: Constants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
      }
      yield put({ type: Constants.GET_CHECKOUT_DETAILS_ERROR, errorDetails });
      yield put({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
      yield put(notificationActions.showErrorNotification(apiResponse?.data?.errors?.[0]?.message));
      yield put({ type: Constants.CEF_CHECKOUT_DETAILS_ERROR, response: errorDetails, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      if (apiResponse && apiResponse.request && apiResponse.request.status === 200) {
        yield put({ type: Constants.GET_CHECKOUT_DETAILS_SUCCESS, response: true });
      }
    }
    if (isExpressCheckout() && restResponse?.length > 0 && isCassNeeded) {
      const cqResponse = restResponse[0];
      if (cqResponse.status === 'fulfilled' && cqResponse?.v?.data) {
        window.checkoutCQ = cqResponse.v.data || {};
      }
    }
    hideLoader();
  } catch (error) {
    if (error && error.message) {
      yield put({ type: 'UPDATE_API_STATUS', response: 'FAILED' });
      hideLoader();
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_CHECKOUT_DETAILS, callGetCheckoutDetails);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
